import { _EVENT_NAMES } from './AnalyticsEvents'
import { analytics } from './Analytics'

export const sendPricingErrorAnalytics = (error) => {
  analytics.track(_EVENT_NAMES.PRICING_GENERAL_ERROR, {
    Error: error,
  })
}
